import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import appReducer from '@modules/app/redux/reducer';
import authReducer from '@modules/auth/redux/reducer';
import settingsReducer from '@modules/settings/redux/reducer';

const rootReducer = (history) => {
  return combineReducers({
    router: connectRouter(history),
    app: appReducer,
    auth: authReducer,
    settings: settingsReducer,
  });
};

export default rootReducer;
